import { api, apis, getOs } from 'api';
const htmlApi = api.requireLogicalApi(apis.htmlApi);
const isMac = getOs() === 'mac';
export const toFixed = (num, figure = 0) => {
    const base = window.Math.pow(10, figure);
    return window.Math.round(num * base) / base;
};
export const formatFileSize = (size, base) => {
    base = base || isMac ? 1024 : 1000;
    let baseSize = window.Math.pow(base, 3);
    if (size >= baseSize) {
        return toFixed(size / baseSize, 1) + 'G';
    }
    baseSize /= base;
    if (size >= baseSize) {
        return toFixed(size / baseSize, 1) + 'M';
    }
    baseSize /= base;
    if (size >= baseSize) {
        return toFixed(size / baseSize, 1) + 'K';
    }
    return toFixed(size, 1) + 'B';
};
export const sizeTransform = (size, unit = 'M', figure = 1) => {
    const units = ['B', 'K', 'M', 'G', 'T'];
    const index = units.indexOf(unit);
    if (index === -1) {
        return size;
    }
    const base = window.Math.pow(1000, index);
    return toFixed(size / base, figure);
};
export const getFileExt = (filename) => filename.replace(/.+\.(?=\w+$)/, '').toLowerCase();
export const downloadFile = (data, name) => {
    const blob = new Blob([data]);
    const downloadElement = document.createElement('a');
    const href = window.URL.createObjectURL(blob);
    downloadElement.href = href;
    downloadElement.download = name;
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement);
    window.URL.revokeObjectURL(href);
};
export const decodeAttFileName = (fileName) => {
    let res = '';
    try {
        res = decodeURIComponent(fileName);
    }
    catch (_a) {
        res = fileName;
    }
    return htmlApi.decodeHtml(htmlApi.encodeHtml(res));
};
export const getSuffix = (downloadInfo) => {
    var _a;
    const { fileType: type, unDecrypted } = downloadInfo;
    if (type && type !== 'other' && !unDecrypted)
        return type;
    const arr = (_a = downloadInfo === null || downloadInfo === void 0 ? void 0 : downloadInfo.fileName) === null || _a === void 0 ? void 0 : _a.split('.');
    if (arr.length == 1)
        return 'other';
    return arr[arr.length - 1];
};
